export const environment = {
    production: true,
    BACKEND_URL:'https://saasbe.ilooopsqhse.com'
  };



// WEBPACK FOOTER //
// /app/src/environments/environment.ts